import { render, staticRenderFns } from "./model_address.vue?vue&type=template&id=e675b2cc&scoped=true&"
import script from "./model_address.vue?vue&type=script&lang=js&"
export * from "./model_address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e675b2cc",
  null
  
)

export default component.exports